import ELK from 'elkjs/lib/elk.bundled.js';

const elk = new ELK();

// Enhanced ELK layout options with edge routing
const elkOptions = {
  'elk.algorithm': 'layered',
  'elk.direction': 'RIGHT',
  
  // Spacing options
  'elk.spacing.nodeNode': '80',
  'elk.layered.spacing.nodeNodeBetweenLayers': '150',
  'elk.layered.spacing.edgeNodeBetweenLayers': '50',
  
  // Edge routing to avoid nodes
  'elk.edgeRouting': 'ORTHOGONAL',
  'elk.layered.edgeRouting.selfLoopDistribution': 'EQUALLY',
  
  // Node placement for better edge routing
  'elk.layered.nodePlacement.strategy': 'NETWORK_SIMPLEX',
  
  // Consider edge direction
  'elk.layered.considerModelOrder.strategy': 'NODES_AND_EDGES',
  
  // Crossing minimization
  'elk.layered.crossingMinimization.strategy': 'LAYER_SWEEP',
  'elk.layered.crossingMinimization.semiInteractive': 'true',
};

export const getLayoutedElements = async (nodes, edges) => {
  const graph = {
    id: 'root',
    layoutOptions: elkOptions,
    children: nodes.map((node) => {
      let width = 320;
      let height = 200;
      
      if (node.type === 'dispatcherNode') {
        width = 320;
        height = 180;
      } else if (node.type === 'machineNode') {
        // ✅ Check if node has optimization data and increase height
        const hasOptimizationData = node.data?.scheduledJobs > 0;
        width = 320;
        height = hasOptimizationData ? 280 : 200; // Taller after optimization
      }
      
      return {
        id: node.id,
        width: node.width || width,
        height: node.height || height,
      };
    }),
    edges: edges.map((edge) => ({
      id: edge.id,
      sources: [edge.source],
      targets: [edge.target],
    })),
  };

  const layoutedGraph = await elk.layout(graph);

  const layoutedNodes = nodes.map((node) => {
    const layoutedNode = layoutedGraph.children.find((n) => n.id === node.id);
    return {
      ...node,
      position: {
        x: layoutedNode.x,
        y: layoutedNode.y,
      },
    };
  });

  return { nodes: layoutedNodes, edges };
};